import { isLoggedIn as e } from "./myoc.js";
import { validStateCodesCA as t, validStateCodesUS as n } from "@cx-modules/constants";
//#region src/countries-subdivisions.ts
var r = {
	AL: "Alabama",
	AK: "Alaska",
	AS: "American Samoa",
	AR: "Arkansas",
	AZ: "Arizona",
	CA: "California",
	CO: "Colorado",
	CT: "Connecticut",
	DC: "District of Columbia",
	DE: "Delaware",
	FL: "Florida",
	FM: "Federated States of Micronesia",
	GA: "Georgia",
	GU: "Guam",
	HI: "Hawaii",
	ID: "Idaho",
	IL: "Illinois",
	IN: "Indiana",
	IA: "Iowa",
	KS: "Kansas",
	KY: "Kentucky",
	LA: "Louisiana",
	ME: "Maine",
	MD: "Maryland",
	MA: "Massachusetts",
	MI: "Michigan",
	MN: "Minnesota",
	MS: "Mississippi",
	MO: "Missouri",
	MT: "Montana",
	NC: "North Carolina",
	ND: "North Dakota",
	NE: "Nebraska",
	NH: "New Hampshire",
	NJ: "New Jersey",
	NM: "New Mexico",
	NV: "Nevada",
	NY: "New York",
	OH: "Ohio",
	OK: "Oklahoma",
	OR: "Oregon",
	PA: "Pennsylvania",
	PR: "Puerto Rico",
	PW: "Palau",
	RI: "Rhode Island",
	SC: "South Carolina",
	SD: "South Dakota",
	TN: "Tennessee",
	TX: "Texas",
	UT: "Utah",
	VT: "Vermont",
	VA: "Virginia",
	VI: "U.S. Virgin Islands",
	WA: "Washington",
	WI: "Wisconsin",
	WV: "West Virginia",
	WY: "Wyoming",
	MP: "Northern Mariana Islands",
	MH: "Marshall Islands"
}, i = {
	AB: "Alberta",
	BC: "British Columbia",
	MB: "Manitoba",
	NB: "New Brunswick",
	NL: "Newfoundland and Labrador",
	NS: "Nova Scotia",
	NT: "Northwest Territories",
	NU: "Nunavut",
	ON: "Ontario",
	PE: "Prince Edward Island",
	QC: "Quebec",
	SK: "Saskatchewan",
	YT: "Yukon"
}, a = (e, t) => e.reduce((e, n) => (e[n] = {
	code: n,
	name: t[n]
}, e), {}), o = {
	US: {
		code: "US",
		name: "United States",
		subdivisions: a(n, r)
	},
	CA: {
		code: "CA",
		name: "Canada",
		subdivisions: a(t, i)
	}
}, s = /* @__PURE__ */ function(e) {
	return e.desktop = "desktop", e.mobile = "mobile", e.tablet = "tablet", e;
}({}), c = /* @__PURE__ */ function(e) {
	return e[e.mobile = 280] = "mobile", e[e.tablet = 450] = "tablet", e[e.desktop = 1024] = "desktop", e;
}({}), l = {
	LINK: "LINK",
	ALL_SPORTS_EXPANDABLE: "ALL_SPORTS_EXPANDABLE",
	FEATURED_LINKS: "FEATURED_LINKS",
	LINK_GROUP: "LINK_GROUP",
	GROUP: "GROUP",
	SPLIT_EXPANDABLE: "SPLIT_EXPANDABLE",
	FLAT_ITEMS_EXPANDABLE: "FLAT_ITEMS_EXPANDABLE",
	MY_ACCOUNT: "MY_ACCOUNT",
	ODDS_FORMAT: "ODDS_FORMAT",
	BETSLIP: "BETSLIP",
	SETTINGS: "SETTINGS",
	STATE_SELECTOR: "STATE_SELECTOR"
}, u = { PROMO_CODE: "PROMO_CODE" }, d = {
	primary: "primary",
	secondary: "secondary",
	tertiary: "tertiary"
}, f = {
	DISCLAIMER: "DISCLAIMER",
	LOGO: "LOGO"
}, p = {
	AMERICAN: "american",
	DECIMAL: "decimal",
	FRACTIONAL: "fractional",
	TRADITIONAL: "traditional"
}, m = (e) => ({
	American: e === p.AMERICAN,
	Decimal: e === p.DECIMAL,
	Fractional: e === p.FRACTIONAL
}), h = [
	"WS",
	"US",
	"OC",
	"GZ"
], g = {
	GZ: "it",
	OC: "uk",
	US: "us",
	WS: "uk"
}, _ = {
	OC: "uk",
	US: "us",
	WS: "uk",
	GZ: "it"
};
//#endregion
export { i as CA_SUBDIVISION_NAMES, s as Devices, c as MinScreenSizes, p as ODDS_FORMAT, g as REPUB_COUNTRY, _ as REPUB_COUNTRY_BY_REPUB, h as SUPPORTED_REPUB_NAMES, r as US_SUBDIVISION_NAMES, o as countriesByCodeWithSubdivisions, f as footerItemType, m as getOddsFormatIs, e as isLoggedIn, l as navItemType, u as navItemsType, d as variant };
